import React from 'react'
import { chipImg, frameImg } from '../utils'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap';
import { animateWithGsap } from '../utils/animations';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';


const HowItWorks = () => {

  useGSAP(() => {
    gsap.from('#chip', {
      scrollTrigger: {
        trigger: '#chip',
        start: '20% bottom'
      },
      opacity: 0,
      scale: 2,
      duration: 2,
      ease: 'power2.inOut'
    })

    animateWithGsap('.g_fadeIn', {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power2.inOut'
    })
  }, []);

  return (
    <section className="common-padding bg-slate-800">
      <div className="screen-max-width">
        <div className="hi">
        <div id="chip" className="flex-center w-full my-20">
          <img src={chipImg} alt="chip" width={180} height={180} />
        </div>

        <div className="flex flex-col items-center">
          <h2 className="hiw-title">
          Powered by Data, Technology
            <br />   and Expertise
          </h2>
        </div>
        </div>

        <div className="mt-10 md:mt-20 mb-14 px-4">
        <div className="hidden md:grid grid-cols-3 gap-4">
    
            {/* Left Content */}
            <div className="space-y-[100vh] md:space-y-10">
         <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center"
      >
        <h2 className="text-2xl font-bold mb-2">Regional <span className='text-teal-500'>Experts</span></h2>
        <p className="text-gray-100 text-lg">
        Personal relationships with your advisor lead to more profitable investments and a more valuable portfolio. You are matched with an expert with extensive market knowledge to find the best property for your needs.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2">Regional <span className='text-teal-500'>Experts</span></h2>
        <p className="text-gray-100 text-lg">Personal relationships with your advisor lead to more profitable investments and a more valuable portfolio. You are matched with an expert with extensive market knowledge to find the best property for your needs.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }} className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2">Inspected & <span className='text-teal-500'>Verified</span></h2>
        <p className="text-gray-100 text-lg">
        ﻿﻿Gain access to an extensive library of inspection photos to assess the current condition of each property.</p>
      </motion.div>
    </div>

          {/* Sticky Image */}
          <div className="relative">
      <div className="sticky top-28">
        <img
          src={frameImg}
          alt="frame"
          className="bg-transparent z-10 w-60 h-[30rem] mx-auto"
        />
      </div>
    </div>

    {/* Right Content */}
    <div className="space-y-[100vh] md:space-y-10">
    <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2">Data-Driven <span className='text-teal-500'>Estimates</span></h2>
        <p className="text-gray-100 text-lg">
        The accuracy of our metrics, like after repair value (ARV), is backed by our more than 15 years of experience and extensive data collection from the markets we serve.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2">Real <span className='text-teal-500'>Comparables</span></h2>
        <p className="text-gray-100 text-lg">
        Each property has relevant, up-to-date comparables to help our investors make the right choice for their goals.</p>
      </motion.div>
    
    </div>

  </div>
   {/* Mobile View */}
   <div className="md:hidden relative">
    {/* Wrapper that creates enough height for sticky effect */}
    <div className="relative h-[600vh]">
      <div className="sticky top-0 h-screen flex items-center justify-center z-10">
        <img
          src={frameImg}
          alt="frame"
          className="w-60 h-[30rem] mx-auto opacity-40"
        />
      </div>

      <div className="absolute top-0 left-0 right-0">
        {/* Left content */}
      
         <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center"
      >
        <h2 className="text-2xl font-bold mb-2">Regional <span className='text-teal-500'>Experts</span></h2>
        <p className="text-white">
        Personal relationships with your advisor lead to more profitable investments and a more valuable portfolio. You are matched with an expert with extensive market knowledge to find the best property for your needs.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2">Regional <span className='text-teal-500'>Experts</span></h2>
        <p className="text-white">Personal relationships with your advisor lead to more profitable investments and a more valuable portfolio. You are matched with an expert with extensive market knowledge to find the best property for your needs.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }} className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2">Inspected & <span className='text-teal-500'>Verified</span></h2>
        <p className="text-white">
        ﻿﻿Gain access to an extensive library of inspection photos to assess the current condition of each property.</p>
      </motion.div>
   
      

        {/* Right content */}
        <div className="space-y-[100vh]">
        
    <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2">Data-Driven <span className='text-teal-500'>Estimates</span></h2>
        <p className="text-white">
        The accuracy of our metrics, like after repair value (ARV), is backed by our more than 15 years of experience and extensive data collection from the markets we serve.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2">Real <span className='text-teal-500'>Comparables</span></h2>
        <p className="text-white">
        Each property has relevant, up-to-date comparables to help our investors make the right choice for their goals.</p>
      </motion.div>
    
    </div>
          {/* Your motion divs */}
        </div>
      
    </div>
  </div>
</div>


<div className="relative z-20 -mt-[46vh] md:-mt-[36vh] bg-teal-500 p-10">
  <div className="flex flex-col md:flex-row items-center justify-between gap-6">
    <div className="flex-1 flex justify-center flex-col g_fadeIn text-white">
      <p className="hiw-bigtext text-3xl font-bold">Let’s Start Working Together</p>             
    </div>
    <div className="flex-1 flex justify-center flex-col text-white">
      <p className="text-lg g_fadeIn text-white">
        Join the thousands of investors who have enjoyed success with PropertyForce. Schedule a meeting with one of our experts today.
      </p>
      <Link to="/contact"> 
        <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-slate-900 shadow-xl text-lg group">
          <span className="absolute inset-0 bg-gradient-to-r from-teal-600 to-teal-600 group-hover:from-teal-600 group-hover:to-teal-600 animate-slide-bg transition-all duration-500 ease-in-out"></span>
          <span className="relative z-10">Get Started</span>
        </button>
      </Link>     
    </div>
  </div>
</div>


     </div>
    </section>
  )
}

export default HowItWorks